import clsx from 'clsx'
import map from 'lodash/map'
import takeRight from 'lodash/takeRight'
import React, { ComponentProps, memo } from 'react'
import type { BreadcrumbList, WithContext } from 'schema-dts'

import AngleRight from '@Assets/SVG/AngleRight'
import { Breadcrumb } from '@Components/Breadcrumbs/breadcrumb'
import { Link } from '@Components/Link'

import styles from './Breadcrumbs.module.scss'

export const Breadcrumbs = memo(({
  breadcrumbs,
  className,
  maxElements,
  ...props
}: {
  breadcrumbs: Breadcrumb[]
  maxElements?: number
} & ComponentProps<'div'>) => {
  const schema: WithContext<BreadcrumbList> = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: breadcrumbs.map((crumb, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: crumb.title,
      item: crumb.url || '',
    })),
    itemListOrder: 'http://schema.org/ItemListOrderAscending',
    numberOfItems: breadcrumbs.length,
  }

  return (
    <div className={clsx(className, styles.wrapper)} {...props}>
      <ol className={styles.breadcrumbs}>
        {map(takeRight(breadcrumbs, maxElements || breadcrumbs.length), (breadcrumb) => {
          let content = (
            <span>{breadcrumb.title}</span>
          )

          if (breadcrumb.url) {
            content = (
              <Link
                analytics={{
                  dest_page_type: breadcrumb.type,
                  dest_page_type_id: breadcrumb.id,
                  source_id: 'breadcrumb',
                }}
                href={breadcrumb.url || '/'}
              >
                {content}
              </Link>
            )
          }

          return (
            <li key={`${breadcrumb.type}-${breadcrumb.id}`} className={clsx('breadcrumb', styles.breadcrumb)}>
              <AngleRight className={styles.angle} />

              {content}
            </li>
          )
        })}
      </ol>
      <script dangerouslySetInnerHTML={{ __html: JSON.stringify(schema).replace(/</g, '\\u003c') }} type="application/ld+json" />
    </div>
  )
})
